import React from 'react'
import { MainBanner, FinalCont, CircleCont ,FinalCirc1, FinalCirc2, FinalCirc3} from './Finalsec.style'

export default function FinalSec(){
    return (
        <div>
            <MainBanner>
                <FinalCont>
                    <CircleCont>
                        <FinalCirc1>
                            <img href="Irving de Lira" src='https://res.cloudinary.com/dojodevs/image/upload/v1581788175/smartia/RECURSOS/Irving-06_jdielk.png'/>
                            <h3>Irving de Lira</h3>
                            <p>PhD – Managing Partner</p>
                        </FinalCirc1>
                        <FinalCirc2>
                            <img href="Andrea Vargas" src='https://res.cloudinary.com/dojodevs/image/upload/v1581789003/smartia/RECURSOS/Andrea-06-06_y0ttsq.png'/>
                            <h3>Andrea Vargas</h3>
                            <p>Analista</p>
                        </FinalCirc2>
                        <FinalCirc3>
                            <img href="Raúl Galicia" src='https://res.cloudinary.com/dojodevs/image/upload/v1581789003/smartia/RECURSOS/Rau%CC%81l-06-06_xvhjbe.png'/>
                            <h3>Raúl Galicia</h3>
                            <p>MPA-ID - Managing Partner</p>
                        </FinalCirc3>
                    </CircleCont>
                </FinalCont>
            </MainBanner>
        </div>
    )
}